import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.5.1_@types+node@20.17.41_db0@0.3.2_eslint@8.57.1_ioredis@_7c4204005e5bfe3774832cebe828f4b2/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}